import React, { useMemo } from 'react';
import { GetSiteName } from '../../utilities/SiteUtilities';
export const SiteName = ({ accountNumber, siteGroup, origin, }) => {
    const siteName = useMemo(() => GetSiteName(siteGroup || "tb", origin, accountNumber), [
        accountNumber,
        siteGroup,
        origin,
    ]);
    return React.createElement(React.Fragment, null, siteName);
};
//# sourceMappingURL=SiteName.js.map